<template>
  <div class="legal-page">
    <h1>使用条款</h1>
    <p><strong>最后更新日期：【2026】年【3】月【14】日</strong></p>

    <p>欢迎使用【LiAng】。本网站由【LiAng】运营。以下条款和条件（“使用条款”）约束您对本网站的使用。访问或使用本网站，即表示您同意受这些使用条款的约束[citation:2][citation:8]。</p>

    <h2>1. 接受条款</h2>
    <p>通过访问或使用本网站，您确认您已阅读、理解并同意受本使用条款的约束，并遵守所有适用的法律和法规。如果您不同意本条款的任何部分，请勿使用本网站。</p>

    <h2>2. 知识产权</h2>
    <p>
      本网站上的所有内容，包括但不限于文本、图形、标志、图标、图像、音频剪辑、数字下载、数据汇编和软件，均为【LiAng】或其内容提供者的财产，受中国及国际版权法的保护[citation:8]。本网站整体内容的编辑和汇编，其知识产权归【LiAng】所有[citation:8]。未经我们明确的书面同意，您不得以任何方式复制、修改、分发、出售或出租本网站的任何部分。
    </p>

    <h2>3. 商标</h2>
    <p>【LiAng】的名称、标识以及与本网站相关的所有其他商标、服务标志和商业外观，均为【LiAng】的商标或商业外观[citation:8]。未经我们事先书面许可，不得使用这些商标。</p>

    <h2>4. 网站使用许可</h2>
    <p>我们授予您一项有限的、非排他的、不可转让的个人许可，允许您访问和个人使用本网站。此许可不包括以下行为[citation:8]：</p>
    <ul>
      <li>对本网站或其内容的任何商业性使用或转售；</li>
      <li>对本网站内容的任何衍生使用；</li>
      <li>为任何目的使用任何数据挖掘、机器人或类似的数据收集和提取工具；</li>
      <li>未经我们书面同意，以任何方式复制、再制、拷贝、出售、转售或利用本网站的任何部分。</li>
    </ul>

    <h2>5. 用户行为</h2>
    <p>
      作为使用本网站的条件，您保证不会将本网站用于任何非法或本条款禁止的目的[citation:8]。您不得以任何可能损坏、禁用、过载或损害本网站的方式使用本网站。您不得尝试通过黑客攻击、密码破解或任何其他方式，未经授权访问本网站的任何部分或功能。
    </p>

    <h2>6. 用户生成内容（如适用）</h2>
    <p>
      如果本网站允许您发布评论、反馈或其他内容，您授予【LiAng】一项非排他的、永久的、免版税的、全球范围的许可，以使用、复制、修改、改编、出版和翻译这些内容，用于与本网站相关的任何目的[citation:8]。您声明并保证您发布的内容是您原创的，或不侵犯任何第三方的知识产权[citation:8]。
    </p>

    <h2>7. 免责声明</h2>
    <p>
      本网站及其内容按“现状”和“可用”的基础提供，不附带任何形式的明示或暗示的保证[citation:8]。在适用法律允许的最大范围内，【LiAng】否认所有明示或暗示的保证，包括但不限于对适销性、特定用途适用性和不侵权的暗示保证[citation:5]。我们不保证本网站的功能不会中断或没有错误，不保证缺陷会得到纠正，也不保证网站或服务器没有病毒或其他有害组件。
    </p>

    <h2>8. 责任限制</h2>
    <p>在适用法律允许的最大范围内，【LiAng】不对因使用或无法使用本网站而引起的任何直接的、间接的、偶然的、特殊的或后果性的损害赔偿承担责任，即使我们已被告知此类损害的可能性[citation:5][citation:8]。
    </p>

    <h2>9. 外部链接</h2>
    <p>本网站可能包含指向不受我们控制的第三方网站的链接。我们对任何第三方网站的内容、隐私政策或做法不承担任何责任。您使用这些链接需自担风险[citation:8]。</p>

    <h2>10. 条款的修改</h2>
    <p>我们保留随时修改本使用条款的权利。任何修改后的条款将在本页面上发布，并附上更新的“最后更新日期”。您继续使用本网站即表示您接受修改后的条款[citation:2]。</p>

    <h2>11. 适用法律与争议解决</h2>
    <p>
      本使用条款应受中华人民共和国法律管辖，不考虑其法律冲突原则[citation:5]。因本使用条款或您使用本网站所引起的任何争议，应首先通过友好协商解决；协商不成的，任何一方均可向【被告所在地/你所在地】有管辖权的人民法院提起诉讼[citation:5][citation:8]。
    </p>

    <h2>12. 联系我们</h2>
    <p>如对这些条款有任何疑问，请联系我们：</p>
    <p>电子邮件：【1051966401@qq.com】</p>
  </div>
</template>